import * as React from "react"

const Query = (props) => (
  <svg width={24} height={21} xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{"Query"}</title>
    <path
      d="M8.25 0a8.25 8.25 0 0 1 6.34 13.529l6.19 6.19a.75.75 0 0 1-.976 1.134l-.084-.073-6.191-6.19A8.25 8.25 0 1 1 8.25 0Zm0 1.5a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5Z"
      fill="#B3D4F5"
      fillRule="evenodd"
    />
  </svg>
)

export default Query;